import adminInstance, { webInstance } from '../services/Axios';
import { handle403Error } from './fetchUtils';
import axios from 'axios';

const isProtectedResource = (url) => {
  if (url.includes('api/loan/get-all-proposals-customized')) return false;
  if (url.includes('/user/delete-user')) return false;
  if (url.includes('/delete-user')) return true;
  return url.includes('lender') ||
    url.includes('api/onepager') ||
    url.includes('api/one-pager') ||
    url.includes('api/cma') ||
    url.includes('s3/get-url') ||
    url.includes('proposal') ||
    url.includes('offer') ||
    url.includes('user-register') ||
    url.includes('get-users-by-type') ||
    url.includes('get-user-by-id') ||
    url.includes('api/notify') ||
    url.includes('api/get-company-details') ||
    url.includes('api/get-company-summary') ||
    url.includes('api/order') ||
    url.includes('api/loan/resume') ||
    url.includes('api/notifications') ||
    url.includes('industry/industry') ||
    url.includes('industry/sector') ||
    url.includes('api/loan/get-application-details') ||
    url.includes('api/loan/apply') ||
    url.includes('api/documents/download')
};

const getInstance = (url) => isProtectedResource(url) ? webInstance : adminInstance;

const getHeaders = (url) => {
  const token = localStorage.getItem("token");
  return {
    Authorization: token ? `Bearer ${token}` : undefined,
    ExchangeMechanism: isProtectedResource(url)
  };
};

// Wrapper Functions for Admin API Calls
export function getWrapper(url, isExternalUrl = false) {
  return new Promise(async (resolve, reject) => {
    try {
      if (isExternalUrl) {
        const res = await axios.get(url, { withCredentials: false });
        return resolve(res.data);
      } else {
        const headers = getHeaders(url);
        const res = await getInstance(url).get(url, { headers });
        return resolve(res.data);
      }
    } catch (e) {
      return reject(e);
    }
  });
}


export function deleteWrapper(url) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getHeaders(url);
      const res = await getInstance(url).delete(url, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

export function postWrapper(url, data,header) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = { ...getHeaders(url), ...header };
      const res = await getInstance(url).post(url, data, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

export function putWrapper(url, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getHeaders(url);
      const res = await getInstance(url).put(url, data, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

export function putFormDataWrapper(url, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = {
        ...getHeaders(url),
        'Content-Type': 'multipart/form-data',
      };
      const config = {
        headers,
        timeout: 15000
      };
      
      const res = await getInstance(url).put(url, data, config);
      return resolve(res.data);
    } catch (e) {      
console.error('Error in putFormDataWrapper:', e);      
      return reject(e);
    }
  });
}

export function patchWrapper(url) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getHeaders(url);
      const res = await getInstance(url).patch(url, null, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

export const postNotifyWrapper = async (url, data, config = {}) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...getHeaders(url),
      ...(config.headers || {}),
    };

    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
      ...config,
    });

    // Check for 403 error
    handle403Error(response);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('POST request failed:', error);
    throw error; // Rethrow so caller can handle
  }
};


// Wrapper Functions for Web API Calls

export function getWrapperWeb(url) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getHeaders(url);
      const res = await webInstance.get(url, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

export function getWrapperFile(url) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getHeaders(url);
      const res = await getInstance(url).get(url, { headers, responseType: 'blob' });
      return resolve(res);
    } catch (e) {
      return reject(e);
    }
  });
}

export function patchWrapperWeb(url) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getHeaders(url);
      const res = await webInstance.patch(url, null, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}


export function deleteWrapperWeb(url) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getHeaders(url);
      const res = await webInstance.delete(url, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

export function postWrapperWeb(url, data, header) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = { ...getHeaders(url), ...header };
      const res = await webInstance.post(url, data, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

export function postWrapperWebFile(url, data, header = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = { ...getHeaders(url), ...header };
      if (!headers.accept) {
        headers.accept = 'application/pdf';
      }
      if (headers.exchangemechanism === undefined) {
        headers.exchangemechanism = true;
      }
      if (headers.ExchangeMechanism === undefined) {
        headers.ExchangeMechanism = true;
      }
      const res = await webInstance.post(url, data, { headers, responseType: 'blob' });
      return resolve(res);
    } catch (e) {
      return reject(e);
    }
  });
}

export function putWrapperWeb(url, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getHeaders(url);
      const res = await webInstance.put(url, data, { headers });
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

